<template>
  <el-form-item v-bind="$attrs" />
</template>
<script>
export default {
  name: "BaseFormItem",
};
</script>
